import { combineReducers } from 'redux';

const initialState = {
    vignetsList: undefined,
    selected_ids: [],
    vignetCount: 0,
    vignetDetail : undefined,
    tagsAdded : false,
    tagsRemoved: false,
    noteAdded : false,
    vignetsDeleted : false,
    vignetCreated : false,
    searchText : '',
    vignetProps : [],
    vignetsMostviewed : undefined,
    recentVignets   : undefined,
    vignetNotes : undefined,
    vignetTags: undefined,
    graphData : undefined
};

const vignetsData = (state = initialState, action) => {
    console.log( action);
    console.log( state.vignetsList);
    switch(action.type){
        case "VIGNETS_DATA_REQUEST":
            return  state;
        case "VIGNETS_DATA_SUCCESS":
            return {
                ...state,
                vignetsList : (action.vignetsList && action.vignetsList.data) ? action.vignetsList.data.response:[],
                vignetCount :  (action.vignetsList && action.vignetsList.data  && action.vignetsList.data.response) ? action.vignetsList.data.response.length :state.vignetCount,
                vignetsDeleted : false,
                vignetCreated : false

            }
        case "VIGNETS_DATA_SEARCH_SUCCESS":
            return {
                ...state,
                filteredData : action.filteredData ? action.filteredData:state.filteredData,
                vignetCount :  action.filteredData ? action.filteredData.length :state.vignetCount,
                searchText : action.searchText?action.searchText:'',
                userid : action.userid?'1':'',
                sort : action.sort?action.sort : 'new'

            }
        case "VIGNET_DETAIL_SUCCESS":
            return {
                ...state,
                vignetDetail : (action.vignetDetail && action.vignetDetail.data) ? action.vignetDetail.data.response:state.vignetDetail,
                tagsAdded : false,
                tagsRemoved : false
            }
        case "CREATE_VIGNET":
            return {
                ...state,
                vignetCreated  : true
            }
        case "SAVE_TAGS":
            return {
                ...state,
                tagsAdded : !state.tagsAdded
            }
        case "REMOVE_TAGS":
            return {
                ...state,
                tagsRemoved : !state.tagsRemoved
            }
        case "SAVE_NOTE":
            return {
                ...state,
                noteAdded : !state.noteAdded
            }
        case "VIGNET_GRAPH":
            return {
                ...state,
                graphData : (action.analyticsData && action.analyticsData.data) ? action.analyticsData.data.response.graph:state.graphData,
                fbShareCount : (action.analyticsData && action.analyticsData.data) ? action.analyticsData.data.response.fbShareCount:state.graphData,
                waShareCount : (action.analyticsData && action.analyticsData.data) ? action.analyticsData.data.response.waShareCount:state.graphData,
                fbViewCount : (action.analyticsData && action.analyticsData.data) ? action.analyticsData.data.response.fbViewCount:state.graphData,
                waViewCount : (action.analyticsData && action.analyticsData.data) ? action.analyticsData.data.response.waViewCount:state.graphData
            }

         case 'SELECT_VIGNETS':
            if(state.selected_ids) {
                if(state.selected_ids.includes(action.id)) {
                    var index = state.selected_ids.indexOf(action.id)
                    state.selected_ids.splice(index, 1);
                }
                else{
                    state.selected_ids.push(action.id);
                }
            }

            return {
                ...state,
                selected_ids : state.selected_ids
            }
        case 'DELETE_VIGNETS':
                return {
                    ...state,
                    selected_ids : [],
                    vignetsDeleted : true
                }
        case "VIGNETS_SELECTED":
            return {
            ...state,
            selected_ids : state.selected_ids
        }
        case "GET_VIG_PROPS":

            let vignetProps = (action.vignetProps && action.vignetProps.data) ? action.vignetProps.data.response:state.vignetProps;
            if(action.section_name === 'recent') {
                state.recentVignets[action.index].eventTracks = vignetProps;
                console.log(state.recentVignets);
                return {
                    ...state,
                    recentVignets : state.recentVignets
                }
            }
            else if(action.section_name === 'most_viewed') {
                state.vignetsMostviewed[action.index].eventTracks = vignetProps;
                return {
                    ...state,
                    vignetsMostviewed : state.vignetsMostviewed
                }
            }
            else if(action.section_name === 'list') {
               // state.vignetsList[action.index].eventTracks = vignetProps;
                return {
                    ...state,
                    vignetProps : vignetProps
                }
            }
            else if(action.section_name === 'detail') {
                state.vignetDetail.eventTracks = vignetProps;
                return {
                    ...state,
                    vignetsList : state.vignetsList
                }
            }
        case "SET_VIG_PROPS":
            vignetProps = {"click_count": 0,
                "view_count": 0,
                "pageview_count": 0,
                "hotspot_count": 0,
                "imageclick_count": 0,
                "textclick_count": 0,
                "video_count": 0,
                "comment_count": "0"};


            return {
                ...state,
                vignetProps : vignetProps
            }

        case "GET_VIG_TAGS":
                return {
                    ...state,
                    vignetTags : (action.vignetTags && action.vignetTags.data) ? action.vignetTags.data.response:[]
                }
        case "GET_VIG_NOTES":
                return {
                    ...state,
                    vignetNotes : (action.vignetNotes && action.vignetNotes.data) ? action.vignetNotes.data.response:state.vignetNotes
                }

        case "RECENT_VIGNETS_SUCCESS":
            return {
                ...state,
                recentVignets : (action.vignetList && action.vignetList.data) ? action.vignetList.data.response:state.recentVignets,

            }
        case "VIEWED_VIGNETS_SUCCESS":
            return {
                ...state,
                vignetsMostviewed : (action.vignetList && action.vignetList.data) ? action.vignetList.data.response:state.vignetsMostviewed,

            }
        default:
            return state;
    }
}


const vignets = combineReducers({
    vignetsData
})

export default vignets;
export const getVignetsData = state => state.vignets.vignetsData;



// WEBPACK FOOTER //
// ./src/reducers/vignets.js